//@ts-nocheck
import React, { useEffect, useRef, useState } from 'react'
import { useAppDispatch } from '../hooks/useAppDispatch';
import { useAppSelector } from '../hooks/useAppSelector';
import { fetchJobDetails, fetchJobs } from '../store/slices/jobs/jobSlice';
import { useNavigate, useParams, } from 'react-router-dom';
import parse, { domToReact, HTMLReactParserOptions } from 'html-react-parser';
import { Link } from 'react-router-dom';
import AuthValidation from './AuthValidation';
import { Input } from '../components/common';
import JobDetailsTabs from '../components/JobDetailsTabs/JobDetailsTabs';
import { useJobData } from '../components/JobDataProvider';
import { useJobDetails } from '../components/JobDetailsProvider';
import { ListboxButton, ListboxOption, ListboxOptions, Listbox } from '@headlessui/react'
import { DialogBackdrop, DialogPanel, DialogTitle, Dialog } from '@headlessui/react'
import { createCandidateLogin, verifyCandidateOtp } from '../store/slices/jobAuth/JobAuthSlice';
import { CrossIcon, ExclamationIcon } from '../components/icons/Icons';
import { Helmet } from 'react-helmet-async';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';


interface EmailLoginFormProps {
  onSubmit: (email: string) => void;
  onBack: () => void;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}


const EmailLoginForm: React.FC<EmailLoginFormProps> = ({ onSubmit, onBack }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const dispatch = useAppDispatch();

  const { createCandidateStatus, createCandidateError } = useAppSelector((state: RootState) => state.jobauth);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (!emailRegex.test(value)) {
      setError('Please enter a valid email address');
    } else {
      setError('');
    }
  };


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return; // Prevent submission
    }
    const result = await dispatch(createCandidateLogin({ payload: { email } })).unwrap();

    onSubmit(email);
  };





  return (
    <form
      onSubmit={handleSubmit}
      className="mt-[-0.6rem]">
      <label htmlFor="email" className="wg-label mb-2 capitalize inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5 font-medium">
        Email
      </label>
      <input
        type="text"
        value={email}
        onChange={handleChange}
        placeholder="Enter your email"
        className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 outline outline-0  border-[#d1d5db] -outline-offset-1 outline-gray-300 placeholder:text-gray-400 input_hover sm:text-sm/6"
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

      <div className='flex items-center justify-end mt-7'>
        {/* <button className=' text-[13px] text-[#266df0]'>
          Resend Otp
        </button> */}
        <button
          type="submit"
          className="flex justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm 2  button-hover"

        >
          {createCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}

        </button>
        {/* <button
                type="button"
                onClick={onBack}
                className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            >
                Back
            </button> */}
      </div>
    </form>
  );
};

// components/Auth/OtpVerification.tsx
interface OtpVerificationProps {
  email: string;
  onSuccess: () => void;
  onBack: () => void;
  setModalOpen: (open: boolean) => void
}

const OtpVerification: React.FC<OtpVerificationProps> = ({
  email,
  onSuccess,
  onBack,
  setModalOpen
}) => {
  const [otp, setOtp] = useState<string[]>(Array(6).fill(''));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const { verifyCandidateStatus, verifyCandidateError } = useAppSelector((state) => state.jobauth);
  const dispatch = useAppDispatch();


  useEffect(() => {
    // Focus the first input on component mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index: number, value: string) => {
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next input
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    // Handle backspace
    if (e.key === 'Backspace') {
      if (otp[index] === '' && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1]?.focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const pastedNumbers = pastedData.replace(/[^\d]/g, '').split('').slice(0, 6);

    const newOtp = [...otp];
    pastedNumbers.forEach((num, index) => {
      if (index < 6) {
        newOtp[index] = num;
      }
    });
    setOtp(newOtp);

    // Focus last filled input or next empty input
    const focusIndex = Math.min(pastedNumbers.length, 5);
    inputRefs.current[focusIndex]?.focus();
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const otpString = otp.join('');
  //   if (otpString.length === 6) {
  //     // Add your OTP verification logic here
  //     localStorage.setItem('token', 'your-auth-token');
  //     onSuccess();
  //   }
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const otpString = otp.join('');

    if (otpString.length === 6) {
      try {
        const res = await dispatch(verifyCandidateOtp({
          payload: {
            email: email,
            otp: otpString
          }
        })).unwrap();
        if (res.status === 200) {
          localStorage.setItem('accessToken', res?.accessToken);
          localStorage.setItem('email', res?.candidate?.email);
          localStorage.setItem('name', res?.candidate?.name)
          if (typeof onSuccess === 'function') {
            onSuccess();
          }
          setModalOpen(false)

        }



      } catch (error) {
        console.error('OTP verification failed:', error);
      }
    }
  };



  return (
    <form id="otp-form" onSubmit={handleSubmit}>
      <div className="flex items-center justify-center gap-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <input
            key={index}
            ref={el => inputRefs.current[index] = el}
            type="text"
            value={otp[index]}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            className="w-10 h-10 lg:w-14 lg:h-14 text-center border-[#a9a9bc52] focus:border-[2px] input_hover focus:border-solid border-[0.5px] text-[14px] lg:text-[20px] font-[600] text-slate-900 bg-slate-100 hover:border-slate-200 appearance-none rounded-lg p-2 lg:p-4 outline-none focus:bg-white focus:ring-0"
            maxLength={1}
          />
        ))}
      </div>
      <div className="max-w-[260px] mx-auto mt-6">

        <button
          type="submit"
          className="mt-4 w-full rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline button-hover"
          disabled={otp.join('').length !== 6}
        >
          {verifyCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}
        </button>
      </div>
    </form>
    // <form onSubmit={handleSubmit} className="space-y-4">
    //     <input
    //         type="text"
    //         value={otp}
    //         onChange={(e) => setOtp(e.target.value)}
    //         placeholder="Enter OTP"
    //         className="w-full p-2 border rounded"
    //         maxLength={6}
    //         required
    //     />
    //     <button type="submit" className="w-full bg-primary text-white p-2 rounded">
    //         Verify
    //     </button>
    //     <button
    //         type="button"
    //         onClick={onBack}
    //         className="w-full bg-transparent text-gray-500 p-2"
    //     >
    //         Back
    //     </button>
    // </form>
  );
};

// components/Auth/GoogleLoginButton.tsx
interface GoogleLoginButtonProps {
  onSuccess: () => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess }) => {
  const navigate = useNavigate()
  const [loadingGoogle, setLoadingGoogle] = useState(false); // ✅ loading state


  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      setLoadingGoogle(true); // start loading
      try {
        const res = await axios.post(
          'https://atsapi.teamer.app/v1/auth/google',
          { code: codeResponse.code },
          { withCredentials: true }
        );

        if (res.data?.status === 200) {
          localStorage.setItem('accessToken', res.data.data?.accessToken);
          localStorage.setItem('email', res.data.data?.candidate?.email);
          localStorage.setItem('name', res.data.data?.candidate?.name)
          navigate('/applications')
          if (typeof onSuccess === 'function') {
            onSuccess();
          }


        }
      } catch (err) {
        console.error('Login failed:', err);
      } finally {
        setLoadingGoogle(false); // stop loading
      }
    },
    onError: (errorResponse) => {
      console.error('Google login error:', errorResponse);
      setLoadingGoogle(false)
    },
  });

  return (
    <button
      onClick={() => login()}
      className="flex w-full items-center h-[40px] justify-center gap-3 rounded-md px-3 py-2 text-sm font-semibold text-gray-900 border border-solid border-[#e7e7e8]"
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 488 512"
        focusable="false"
        className=""
        aria-hidden="true"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
      </svg>
      {loadingGoogle ? (
        <div className='flex items-center justify-center gap-[12px]'>
          Continue with Google
          <div className="simple-spinner">
            <span style={{borderRightColor: '#20808d'}}></span>
          </div>
        </div>
      ) : (
        'Continue with Google'
      )}

    </button>
  );
};



function JobDetails({ onLoginSuccess }) {
  const dispatch = useAppDispatch();
  const {
    fetchJobDetailsLoading, fetchJobDetailsError, fetchJobDetailsData
  } =
    useAppSelector((state) => state.jobs);
  const { base_slug, jobId } = useParams(); // Get both parameters
  const [is404, setIs404] = useState(false);
  const navigate = useNavigate()
  const { jobDetailsData, loading, error } = useJobData();
  const { jobDetails1, loading1, error1, is4041 } = useJobDetails();
  const [otpSaveDetails, setOtpSaveDetails] = useState('')
  const [ModelOpen, setModalOpen] = useState(false)
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [LoginLoading, SetLoginLoading] = useState(false)
  const [step, setStep] = useState<'initial' | 'email' | 'otp'>('initial');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [email, setEmail] = useState('');


  // useEffect(() => {
  //   if (!base_slug) return;
  //   dispatch(fetchJobs(base_slug));
  // }, [base_slug]);

  // job listing by department
  // useEffect(() => {
  //   if (!base_slug || !jobId) return;
  //   setIs404(false);
  //   // if (!jobs?.base) {
  //   dispatch(fetchJobDetails({ baseSlug: base_slug, jobId: jobId }))
  //     .unwrap()
  //     .catch((error) => {
  //       if (error?.data?.statusCode === 404) {
  //         setIs404(true);
  //       }
  //     });
  //   // }
  // }, [dispatch, base_slug, jobId]);

  useEffect(() => {
    if (jobDetailsData?.base?.primary_color) {
      document.documentElement.style.setProperty('--component-primary-color', jobDetailsData?.base?.primary_color);
      const lighter = calculateLighterShade(jobDetailsData?.base?.primary_color, 0.26);
      const mainBgShare = calculateLighterShade(jobDetailsData?.base?.primary_color, 0.93);
      // setLighterShade(lighter);
      document.documentElement.style.setProperty('--hover-primary-color', lighter);
      document.documentElement.style.setProperty('--main-bg-color', mainBgShare);
    }
  }, [jobDetailsData?.base?.primary_color]);

  // Helper function to calculate lighter shade for hover state
  const calculateLighterShade = (hex: any, percent: any) => {
    // Remove the hash if it exists
    hex = hex.replace('#', '');

    // Convert hex to RGB
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Calculate lighter values (adding the percentage)
    r = Math.min(255, Math.round(r + (255 - r) * percent));
    g = Math.min(255, Math.round(g + (255 - g) * percent));
    b = Math.min(255, Math.round(b + (255 - b) * percent));

    // Convert back to hex
    const toHex = (n: any) => {
      const hex = n.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };


  useEffect(() => {
    // Get the email from localStorage
    const emailFromStorage = localStorage.getItem('email');
    if (emailFromStorage) {
      setOtpSaveDetails(emailFromStorage);
    }

    // Function to close dropdown when clicking outside
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    // Add event listener when dropdown is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, otpSaveDetails]);




  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('email');
    localStorage.removeItem('name');
    window.location.reload();

  }

  if (is404) {
    return <AuthValidation />;
  }


  const getDepartmentName = () => {
    if (!fetchJobDetailsData?.job_department_id || !jobDetailsData?.department) return null;
    const matchedDepartment = jobDetailsData.department.find(dept => dept.id === fetchJobDetailsData.job_department_id);
    return matchedDepartment ? matchedDepartment.department_name : null;
  };

  const getLocationName = () => {
    if (!fetchJobDetailsData?.job_location || !jobDetailsData?.location) return null;
    const matchedDepartment = jobDetailsData.location.find(dept => dept.id === fetchJobDetailsData.job_location);
    return matchedDepartment ? matchedDepartment.location_name : null;
  };


  const renderJobContent = () => {
    if (fetchJobDetailsLoading) {
      return (
        <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
          <div className="simple-spinner-loader">
            <span></span>
          </div>
        </div>
      );
    }

    // Custom options for HTML parsing
    const options: HTMLReactParserOptions = {
      replace: (domNode) => {
        if (domNode.type === 'tag' && domNode.name === 'p') {
          // Check if paragraph is empty or only contains whitespace
          const isEmpty = !domNode.children?.length ||
            (domNode.children.length === 1 &&
              domNode.children[0].type === 'text' &&
              !domNode.children[0].data?.trim());

          if (isEmpty) {
            return <br />;
          }

          // For non-empty paragraphs, render them normally with the ProseMirror class
          return (
            <p className="ProseMirror mb-0  whitespace-pre-wrap">
              {domToReact(domNode.children, options)}
            </p>
          );
        }
      }
    };


    const handleApply = () => {
      navigate(`/${base_slug}/${jobId}/apply`)
    }


    if (fetchJobDetailsError) {
      return (
        <div className="text-red-500 text-center">

          Failed to load job details
        </div>
      );
    }

    if (!fetchJobDetailsData) {
      return (
        <div className="text-center">
          <hr className="mt-20 mb-10" />
          No job details available
        </div>
      );
    }



    return (
      <>


        <div className='mb-6'></div>
        {fetchJobDetailsData?.job_description_html && (
          <div className="ProseMirror max-w-none min-h-[155px]">
            {parse(fetchJobDetailsData.job_description_html, options)}
          </div>
        )}


        <div className='flex justify-center items-start mt-8 mb-6 lg:px-[46px] ml-4'>
          <button
            type="button"
            onClick={handleApply}
            style={{
              background: 'var(--component-primary-color)',
            }}
            className="button-hover inline-flex shrink-0 justify-center rounded-md capitalize  px-[90px] py-[10px] text-sm font-semibold leading-5 text-white shadow-sm"

          // className="rounded-md bg-indigo-600 w-[200px] px-2.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Apply
          </button>
        </div>
      </>
    );
  };

  const jobDetails = [
    jobDetails1?.job_type && {
      type: 'job_type',
      label:
        jobDetails1?.job_type === 'Full_Time'
          ? 'Full time'
          : jobDetails1?.job_type === 'Part_Time'
            ? 'Part time'
            : jobDetails1?.job_type === 'Contract'
              ? 'Contract'
              : jobDetails1?.job_type === 'Internship'
                ? 'Internship'
                : jobDetails1?.job_type === 'Temporary'
                  ? 'Temporary'
                  : jobDetails1?.job_type === 'Volunteer'
                    ? 'Volunteer'
                    : jobDetails1?.job_type === 'Other'
                      ? 'Other'
                      : jobDetails1?.job_type
    },
    jobDetails1?.job_workplace_type && {
      type: 'job_workplace_type',
      label:
        jobDetails1?.job_workplace_type === 'On_site'
          ? 'On-site'
          : jobDetails1?.job_workplace_type === 'Hybrid'
            ? 'Hybrid'
            : jobDetails1?.job_workplace_type === 'Remote'
              ? 'Remote'
              : jobDetails1?.job_workplace_type


    },
    jobDetails1?.experience_level && {
      type: 'experience_level',
      label:
        jobDetails1?.experience_level === 'Intern'
          ? 'Intern'
          : jobDetails1?.experience_level === 'Entry Level (0 - 2  years)'
            ? 'Entry Level (0 - 2  years)'
            : jobDetails1?.experience_level === 'Mid (3 - 7 years)'
              ? 'Mid (3 - 7 years)'
              : jobDetails1?.experience_level === 'Senior (8 - 12 years)'
                ? 'Senior (8 - 12 years)'
                : jobDetails1?.experience_level === 'Executive (15+ years)'
                  ? 'Executive (15+ years)'
                  : jobDetails1?.experience_level
    },
    getDepartmentName() && { type: 'department', label: getDepartmentName() },
    getLocationName() && { type: 'location', label: getLocationName() },
  ].filter(Boolean);


  const handleLoginOpenModal = () => {
    // setModalOpen(true)
    // setStep('initial');
    navigate('/')
  }


  // Tooltip content for each job detail type
  // Tooltip content for each job detail type
  const getTooltipContent = (type, value) => {
    switch (type) {
      case 'job_type':
        return `job type`;
      case 'job_workplace_type':
        return `job workplace type`;
      case 'experience':
        return `${type}`;
      case 'department':
        return `${type}`;
      case 'location':
        return `location`;
      default:
        return value;
    }
  };

  const jobTitle = jobDetails1?.job_title;
  const ogImageUrl = jobDetails1?.og_image; // Make sure 'og_image' and 'url' exist
  const jobDescription = jobDetails1?.job_description_html; // Assuming 'description' exists
  const canonicalUrl = `https://jobs.teamer.app/${base_slug}/${jobId}`; // Construct the canonical URL for this job

  return (
    <>
      <Helmet>
        {/* Basic SEO Title (important for browser tab) */}
        <title>{jobTitle ? `${jobTitle}` : "Job Details - Teamer Jobs"}</title>

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={jobTitle || "Explore Job Opportunities on Teamer"} />
        <meta property="og:description" content={"Find your next career move at Teamer. Browse exciting job openings across various industries."} />
        {ogImageUrl && <meta property="og:image" content={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${ogImageUrl}`} />} {/* Only render if ogImageUrl exists */}
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" /> {/* You might use 'article' or similar if jobs are like articles */}

        {/* Twitter Card Meta Tags (optional, but highly recommended) */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={jobTitle || "Explore Job Opportunities on Teamer"} />
        <meta name="twitter:description" content={"Find your next career move at Teamer. Browse exciting job openings across various industries."} />
        {ogImageUrl && <meta name="twitter:image" content={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${ogImageUrl}`} />}

        {/* You can add more meta tags as needed */}
        {/* <link rel="canonical" href={canonicalUrl} /> */}
      </Helmet>
      <div className="flex-1 p-0 h-full main-bg-background">
        <div className="min-h-full max-w-full" style={{ margin: "0px auto" }}>
          <div className="flex items-stretch flex-row gap-0 w-full h-full relative overflow-x-hidden overflow-y-hidden">
            <main className="relative flex-1 flex">
              <div className="overflowing-element hovered mq1023:max-w-full mq1800:max-w-[100%] mq3000:max-w-[100%] flex-1 w-full overflow-y-auto h-screen">
                <div className='pt-1 lg:pt-3 pb-1 cursor-pointer flex justify-end px-3'>
                  {/* 
                  {loading || !jobDetailsData?.base?.logo ? (
                    <div className="h-6 w-6 rounded-[5px] bg-gray-300 animate-pulse"></div>
                  ) : (
                    <img
                      src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobDetailsData?.base?.logo}`}
                      alt="Company Logo"
                      className="h-6 w-6 rounded-[5px]"
                    />
                  )} */}

                  {otpSaveDetails ? (
                    <Listbox value={dropdownOpen} onChange={setDropdownOpen}>
                      {({ open }) => (
                        <div className="relative z-10 flex">
                          <ListboxButton className="relative w-auto min-w-[110px] flex items-center gap-[6px]  pl-3 py-[0px]   cursor-pointer">
                            <div className='flex items-center gap-1.5 justify-between hover:ring-1 ring-gray-200 p-1 rounded-md'>
                              <span className="block truncate text-[13px] font-medium text-gray-600">{otpSaveDetails}</span>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-3">
                                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                              </svg>
                            </div>
                          </ListboxButton>

                          <ListboxOptions className="absolute z-10 mt-1 top-[32px] right-0 bg-white w-full overflow-hidden rounded-lg border border-gray-200 p-1 shadow-lg">
                            <ListboxOption
                              key="applicationlist"
                              value={true}
                              onClick={() => navigate('/applications')}

                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                                )
                              }
                            >
                              <span className="block truncate font-normal leading-4">Application List</span>
                            </ListboxOption>

                            <ListboxOption
                              key="logout"
                              value={true}
                              onClick={handleLogout}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                                )
                              }
                            >
                              <span className="block truncate font-normal leading-4">Logout</span>
                            </ListboxOption>
                          </ListboxOptions>
                        </div>
                      )}
                    </Listbox>
                  ) : (
                    <span
                      onClick={handleLoginOpenModal}
                      className='flex w-fit items-center gap-[6px] text-[13px] capitalize rounded-md px-2 py-1 text-xs font-medium text-gray-600 hover:ring-1 ring-gray-200'
                    >
                      Login
                    </span>
                  )}
                </div>
                <div className="max-w-full md:max-w-[710px] lg:max-w-[710px] pb-4 rounded-none md:rounded-2xl lg:rounded-2xl m-auto my-0 md:my-4 lg:my-2 bg-white">
                  {/* {loading ? (
                    <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  ) : error ? (
                    <div className="text-red-500 text-center">Failed to load jobs</div>
                  ) : ( */}
                  <>
                    {/* <Link to={`/${base_slug}`}>
                      <div className=" relative">
                        <img
                          src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobs?.base?.cover_image}`}
                          alt="Cover Image"
                          className="w-full object-cover rounded-t-2xl h-full max-h-[200px]"
                        />
                        <img
                          src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobs?.base?.logo}`}
                          alt="Cover Image"
                          className="h-[88px] w-[88px] border-[5px] border-solid border-[#f5f5f5]  rounded-[2rem] absolute top-[152px] left-[50px]"
                        />
                      </div>
                    </Link> */}
                    <Link to={`/${base_slug}`}>
                      <div className="relative">
                        {loading || !jobDetailsData?.base?.cover_image ? (
                          <div className="w-full object-cover rounded-t-none md:rounded-t-2xl lg:rounded-t-2xl h-full max-h-[200px] min-h-[200px] bg-gray-300 animate-pulse"></div>
                        ) : (
                          <img
                            src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobDetailsData?.base?.cover_image}`}
                            alt="Cover Image"
                            className="w-full object-cover rounded-t-none md:rounded-t-2xl lg:rounded-t-2xl h-full max-h-[200px] min-h-[200px]"
                          />
                        )}

                        {loading || !jobDetailsData?.base?.logo ? (
                          <div className="h-[70px] md:h-[88px] lg:h-[88px] w-[70px] md:w-[88px] lg:w-[88px] border-[5px] border-solid border-[#f5f5f5]
                           rounded-2xl md:rounded-[2rem] lg:rounded-[2rem absolute  top-[164px] lg:top-[160px]  left-[18px]
                              md:left-[50px] lg:left-[50px] bg-gray-300 animate-pulse"
                          ></div>
                        ) : (
                          <img
                            src={`https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/${jobDetailsData?.base?.logo}`}
                            alt="Company Logo"
                            className="h-[70px] md:h-[88px] lg:h-[88px] w-[70px] md:w-[88px] lg:w-[88px] border-[5px] border-solid border-[#f5f5f5] bg-[#f5f5f5] rounded-2xl 
                                            md:rounded-[2rem] lg:rounded-[2rem] absolute  top-[164px] lg:top-[160px]  left-[18px] md:left-[50px] lg:left-[50px]"
                          />
                        )}
                      </div>
                    </Link>
                    <div className='px-4 md:px-2 lg:px-[46px] w-full max-w-full ml-0 lg:ml-[5px]'>

                      {
                        is4041 ? (
                          <div className='w-full mt-0 flex justify-center items-center flex-col gap-y-3 bg-white' style={{ height: 'calc(69vh - 144px)' }}>
                            <ExclamationIcon />
                            <p className='text-[#0000007a] text-[13px]'>
                              This job has either been deleted or does not exist.
                            </p>
                          </div>
                        ) : null
                      }
                      {
                        !is4041 && (
                          <>
                            <div className="mb-[10px] lg:mb-[15px] mt-[40px] capitalize md:mt-[50px] lg:mt-[67px] w-full p-0 text-[20px] md:text-[24px] lg:text-[24px] leading-7 font-medium text-dark-black-100">
                              {jobDetails1?.job_title}
                            </div>
                            <div>

                              {jobDetails.length > 0 && (
                                <div className="flex items-center flex-wrap lg:flex-nowrap gap-x-2">
                                  {jobDetails.map((item, index) => (
                                    <div
                                      key={index}
                                      className="items-center capitalize gap-x-2 rounded-lg bg-transparent text-dark-black-200 font-[500] text-[0.8125rem] focus:outline-none justify-start inline-flex"
                                    >
                                      {index > 0 && <span className="h-1 w-1 bg-[#030b3e5c] rounded-xl"></span>}
                                      <div className={`table-tooltip-list h-[25px] before:!bottom-[24px] before:!text-[12px]
                                     ${item.type === 'department' ? 'before:!left-[52px]' : 'before:!left-[26px]'
                                        }`}
                                        data-title={getTooltipContent(item.type, item.label)}>
                                        {item.label}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                              {
                                (jobDetails1?.salary_currency || jobDetails1?.salary_min || jobDetails1?.salary_max || jobDetails1?.salary_duration) &&

                                <div className='flex items-center gap-x-2'>

                                  {
                                    (jobDetails1?.salary_currency || jobDetails1?.salary_min || jobDetails1?.salary_max || jobDetails1?.salary_duration)
                                    &&
                                    <span className="h-1 w-1 bg-[#030b3e5c] rounded-xl block"></span>
                                  }

                                  <div className='flex items-center' data-title="Salary"
                                    className='table-tooltip-list h-[25px] before:!bottom-[24px] before:!left-[75px] before:!text-[12px]'>

                                    {
                                      jobDetails1?.salary_currency &&

                                      <span className='text-dark-black-200 font-[500] text-[0.8125rem]'>
                                        {jobDetails1?.salary_currency}
                                      </span>


                                    }
                                    {
                                      jobDetails1?.salary_min &&

                                      <span className='text-dark-black-200 font-[500] text-[0.8125rem] ml-1'>
                                        {jobDetails1?.salary_min}
                                      </span>

                                    }
                                    {
                                      jobDetails1?.salary_max &&

                                      <span className='text-dark-black-200 font-[500] text-[0.8125rem] mx-1'>
                                        - {jobDetails1?.salary_max}
                                      </span>

                                    }
                                    {
                                      jobDetails1?.salary_duration &&

                                      <span className='text-dark-black-200 font-[500] text-[0.8125rem]'>
                                        {jobDetails1?.salary_duration}
                                      </span>

                                    }
                                  </div>
                                </div>
                              }

                            </div>

                            <div className=' mt-[15px] ml-[0px]'>
                              <JobDetailsTabs baseSlug={base_slug} jobId={jobId} primaryColor={jobDetailsData?.base?.primary_color} />
                            </div>
                            {renderJobContent()}
                          </>
                        )}

                    </div>
                  </>
                  {/* )} */}
                  <div>
                  </div>
                </div>
                <div className='max-w-full md:max-w-[710px] lg:max-w-[710px] m-auto h-auto pb-[52px] lg:pb-0'>
                  <div className='mt-5 w-full max-w-full md:max-w-[710px] lg:max-w-[710px] h-auto'>
                    <p className='text-center block text-[12px] md:text-[12] line-clamp-2 lg:text-[12px] leading-5 font-medium
                   text-[#030b3e5c]'>This site is secured by reCAPTCHA and is subject

                      <br></br>  to  Google’s   Privacy Policy and Terms of Service.
                    </p>
                    <hr className="mt-5"></hr>
                    <div className='flex flex-col items-center lg:flex-row justify-center lg:justify-between flex-wrap lg:flex-nowrap  w-full px-4 lg:px-0 py-5'>
                      <div className='text-[#6B7280] text-[13px] font-[500]'>Powered by
                        <strong className='ml-1'>teamer</strong>
                      </div>
                      <div className='text-[#6B7280] text-[13px] font-[500] flex items-start gap-x-2 lg:gap-x-4'>
                        <a href='https://teamer.app/page/privacy-policy' target='_blank'>Privacy Policy</a>
                        <a href='https://teamer.app/page/terms-of-service' target='_blank'>Terms of Service</a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </main>

          </div>
        </div>
      </div>


      <Dialog open={ModelOpen} onClose={setModalOpen} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-[6px] top-[10px] hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setModalOpen(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                {/* <DialogTitle
                        as="h3"
                        className="text-base font-semibold leading-6 text-gray-900"
                      >
      
                        Login
                      </DialogTitle> */}
                <div className="w-full bg-white py-0 rounded-md mt-0 lg:mt-0 mb-[0rem]">
                  <div className="mb-10 ">
                    <h2 className="text-left font-medium leading-5 text-dark-black-100 text-[16px]">
                      {step === 'initial' && 'Login to teamer'}
                      {step === 'email' && 'Enter Your Email'}
                      {step === 'otp' && 'Enter Your OTP'}
                    </h2>
                  </div>
                  <div>
                    {step === 'initial' && (
                      <div className="space-y-4">
                        <GoogleLoginButton onSuccess={onLoginSuccess} />
                        <div className="relative">
                          <div className="absolute inset-0 flex items-center">
                            <span className="w-full border-t" />
                          </div>
                          <div className="relative flex justify-center">
                            <span className="bg-white px-2 text-dark-black-200">Or continue with</span>
                          </div>
                        </div>
                        <button
                          onClick={() => setStep('email')}
                          className="flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm button-hover"
                        >
                          Continue with Email
                        </button>
                      </div>
                    )}
                    {step === 'email' && (
                      <EmailLoginForm
                        onSubmit={(email) => {
                          setEmail(email);
                          setStep('otp');
                        }}
                        onBack={() => setStep('initial')}
                      />
                    )}
                    {step === 'otp' && (
                      <OtpVerification
                        email={email}
                        onSuccess={onLoginSuccess}
                        onBack={() => setStep('email')}
                        setModalOpen={setModalOpen}
                      />
                    )}
                  </div>
                </div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

    </>

  )
}

export default JobDetails